'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @jsx dom */


var _viskanDekuButton = require('@viskan/viskan-deku-button');

var _viskanDekuButton2 = _interopRequireDefault(_viskanDekuButton);

var _componentCookie = require('component-cookie');

var _componentCookie2 = _interopRequireDefault(_componentCookie);

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	button: {
		type: 'object'
	},
	class: {
		type: 'string'
	},
	cookieName: {
		'type': 'string'
	},
	content: {
		type: 'object'
	},
	isAccepted: {
		type: 'function'
	},
	maxage: {
		type: 'number'
	},
	onClick: {
		type: 'function'
	},
	secure: {
		type: 'boolean'
	},
	styles: {
		type: 'string'
	}
};

var defaultProps = {
	cookieName: 'deku-cookie-accepted',
	maxage: 7889238000
};

var handleClick = function handleClick(_ref, setState) {
	var cookieName = _ref.cookieName,
	    maxage = _ref.maxage,
	    onClick = _ref.onClick,
	    secure = _ref.secure;
	return function () {
		(0, _componentCookie2.default)(cookieName, 'true', { maxage: maxage, secure: secure });

		setState({ active: false });

		if (onClick) {
			onClick();
		}
	};
};

var getButton = function getButton(props, setState) {
	var button = props.button,
	    styleClasses = props.styleClasses;


	if ((typeof button === 'undefined' ? 'undefined' : _typeof(button)) === 'object') {
		if (!button.attributes.onClick) {
			button.attributes.onClick = handleClick(props, setState);
		}

		return button;
	}

	return (0, _magicVirtualElement2.default)(
		_viskanDekuButton2.default,
		{ 'class': 'Cookies-button', styleClasses: styleClasses, onClick: handleClick(props, setState) },
		button
	);
};

var afterMount = function afterMount(_ref2, el, setState) {
	var props = _ref2.props;
	var cookieName = props.cookieName,
	    isAccepted = props.isAccepted;


	if (!(0, _componentCookie2.default)(cookieName)) {
		setState({ active: true });

		if (isAccepted) {
			isAccepted(false);
		}

		return;
	}

	if (isAccepted) {
		isAccepted(true);
	}
};

var shouldUpdate = function shouldUpdate(_ref3, nextProps, _ref4) {
	var props = _ref3.props,
	    state = _ref3.state;
	var active = _ref4.active;
	return !(0, _deepEqual2.default)(props, nextProps) || state.active !== active;
};

var render = function render(_ref5, setState) {
	var props = _ref5.props,
	    state = _ref5.state;
	var content = props.content,
	    styles = props.styles,
	    styleClasses = props.styleClasses;
	var active = state.active;


	if (!active) {
		return (0, _magicVirtualElement2.default)('noscript', null);
	}

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['Cookies', props.class, styleClasses && styleClasses.Cookiebar], 'data-style-attr': 'Cookiebar', style: (!styleClasses || styleClasses && !styleClasses.Cookiebar) && styles },
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['Cookies-content', styleClasses && styleClasses.Content], 'data-style-attr': 'Content' },
			content
		),
		getButton(props, setState)
	);
};

exports.default = { afterMount: afterMount, defaultProps: defaultProps, propTypes: propTypes, render: render, shouldUpdate: shouldUpdate };
